import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { useRemarkSync } from "react-remark"
import styled from "styled-components"

import { components } from "./paragraph-components"

const Paragraph = styled(Box).attrs({
  mb: { _: 2, desktop: 4 },
})`
  &:last-child {
    margin-bottom: 0;
  }
`

const ArticleMarkdown = ({ children, elementId }) => {
  const markdownContent = useRemarkSync(children, {
    rehypeReactOptions: { components },
    suppressHydrationWarning: true,
  })

  return <Paragraph id={elementId}>{markdownContent}</Paragraph>
}

ArticleMarkdown.propTypes = {
  children: PropTypes.string,
  elementId: PropTypes.string,
}

export default ArticleMarkdown
